export const iconFontAwesomeDisasterCrisisLocust = (
	<i className="fa-solid fa-locust"></i>
);
